import { BULL_TINT, BEAR_TINT } from "./format";

type NetValueProps = {
  kind: "debit" | "credit";
  amount: string; // pre-formatted with sign + unit, e.g. "-$1.25 / contract"
};

/** Full-width tinted bar for a spread's net debit (red) or net credit (green). */
const NetValue = ({ kind, amount }: NetValueProps) => (
  <div
    className={`flex items-center justify-between rounded-lg px-3 py-2.5 text-sm font-bold ${
      kind === "debit" ? `${BEAR_TINT} text-error-main` : `${BULL_TINT} text-success-main`
    }`}
  >
    <span>{kind === "debit" ? "Net Debit" : "Net Credit"}</span>
    <span>{amount}</span>
  </div>
);

export default NetValue;
